
<template>
  <div class="record_box">
    <div class="record_item"
         v-if="list.length>0">
      <div class="box"
           v-for="(item,index) in list"
           :key="index">
        <div class="look_limit">
          <img class="logo"
               :src="item.icon" />
          <span class="name">{{item.name}}</span>
          <span v-if="item.tagUrls">
            <img class="tag"
                 v-for="(itm,idx) in item.tagUrls.split(',')"
                 :key="idx"
                 :src="itm" />
          </span>
          <span class="limit right">{{item.exhaustNumber}}人已下载</span>
        </div>
        <div class="item">
          <div class="info">
            <p class="title">{{item.limitStart/10000}}万~{{item.limitEnd/10000}}万 <span class="day">{{item.productLimit}}</span></p>
            <p class="time">{{item.gmtCreated}}</p>
          </div>
          <div class="money">
            <p><span class="lookBag"
                    @click="toProductDetail(item)">立即申请</span></p>
          </div>
        </div>
      </div>
    </div>
    <Empty :propJson="propJson"
           v-if="list.length==0" />
  </div>
</template>

<script>
import Empty from '@/components/empty'
export default {
  components: {
    Empty
  },
  data () {
    return {
      propJson: {
        title: '空空如也~',
      },
      customerId: '',
      list: [],
      money: ''
    }
  },
  mounted () {
    this.util.title('优质口子');
    this.getList();
  },
  methods: {
    //统计埋点
    toCountPoint (item) {
      let json = {
        event_key: 'h5_vip_products_click',
        product_id: item.id,
        product_type: item.type,
      }
      this.$get('/app/api/v1/newEventTrace', json)
        .then(res => {
          if (res.code == 200) {
          }
          else {
            this.util.toast({ msg: res.message })
          }
        })
        .catch(error => { });
    },
    getList () {//绑定银行卡
      let _this = this;
      // let param = {
      //   customerId: this.customerId
      // }
      this.$get('/app/v1/apiproduct/productList', {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.list = e.data;
          }
          else {
            _this.util.toast({ msg: e.msg })
          }
        })
        .catch(error => { });
    },
    toPage (path) {
      // 进入监测页面
      this.$router.push({
        path: path,
        query: {
          money: this.money, customerId: this.customerId
        }
      });
    },
    //调用android和ios的方法
    toProductDetail (item) {
      this.toCountPoint(item)
      let json = {
        "pageUrl": item.pageUrl
      }
      try {
        window.webkit.messageHandlers.toProductDetail.postMessage(json);//ios
      } catch (err) {
        window.AppJs.toProductDetail(JSON.stringify(json));//android
      }
    },

  }

}
</script>
<style scoped>
.record_box {
  font-family: PingFangSC-Regular;
  background: #f7f7f7;
  padding-top: 0.1rem;
}
.pd {
  color: #999;
  font-size: 0.12rem;
}
.look_limit {
  margin-top: 0.08rem;
  padding-bottom: 0.1rem;
  border-bottom: 1px solid #f5f5f5;
  margin-bottom: 0.2rem;
  border-radius: 3px;
}
.tag {
  height: 0.18rem;
  width: 0.32rem;
  position: relative;
  top: -0.06rem;
  left: 0.1rem;
  margin-right: 0.05rem;
}
.name {
  font-size: 0.16rem;
  color: #333;
  font-family: PingFangSC;
  font-weight: 500;
  position: relative;
  top: -0.06rem;
  margin-left: 0.1rem;
}
.logo {
  display: inline-block;
  width: 0.22rem;
  height: 0.22rem;
}
.limit {
  color: #999;
}
.line {
  display: inline-block;
  width: 3px;
  height: 0.12rem;
  background: linear-gradient(
    135deg,
    rgba(255, 172, 85, 1) 0%,
    rgba(255, 57, 31, 1) 100%
  );
  box-shadow: 0px 4px 10px 0px rgba(255, 191, 128, 0.2);
  border-radius: 4px;
  margin-right: 0.05rem;
}
.list {
  float: right;
  border: 1px solid #fff;
  width: 0.8rem;
  height: 0.3rem;
  text-align: center;
  line-height: 0.3rem;
  border-radius: 15px;
  position: relative;
  top: -0.06rem;
  z-index: 11;
}

.allUse_icon {
  display: inline-block;
  width: 0.73rem;
  height: 0.73rem;
  background: url("../../assets/img/vip/allUse.png") no-repeat top center;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-left: 0.15rem;
  border-radius: 50%;
  position: absolute;
  right: 0.19rem;
  top: 0.2rem;
  z-index: 111;
  background-color: rgba(247, 243, 241, 0.4);
}
.dw {
  font-size: 0.14rem;
  top: -0.03rem;
  font-size: 0.14rem;
  position: relative;
  left: -0.06rem;
}
.item {
  display: flex;
  flex: 1;
  justify-content: space-between;
  font-size: 0.14rem;
  font-family: PingFangSC;
  position: relative;
}
.box {
  margin-bottom: 0.1rem;
  background: rgba(255, 255, 255, 1);
  padding: 0.12rem 0.15rem 0.19rem 0.15rem;
  /* padding-bottom: 0.3rem; */
}
.act_bg {
  background: url("../../assets/img/vip/money_bg.png") no-repeat center center;
  background-size: 100% 100%;
}
.by_vip,
.bj_vip,
.hj_vip,
.zs_vip {
  display: inline-block;
  width: 1.36rem;
  height: 0.24rem;
  background: url("../../assets/img/vip/card/by_vip.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.zs_vip {
  background: url("../../assets/img/vip/card/zs_vip.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.hj_vip {
  background: url("../../assets/img/vip/card/hj_vip.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.bj_vip {
  background: url("../../assets/img/vip/card/bj_vip.png") no-repeat center
    center;
  background-size: 100% 100%;
}

.line {
  display: inline-block;
  width: 100%;
  height: 2px;
  background: url("../../assets/img/vip/card/line.png") no-repeat center center;
  background-size: 100% 100%;
}
.item .title {
  font-weight: 500;
  color: #ff514a;
  font-size: 0.2rem;
}
.day {
  color: #484848;
  margin-left: 0.3rem;
}
.item .time {
  color: #666;
  margin-top: 0.05rem;
  font-size: 0.12rem;
}
.item .gray {
  color: #666;
  font-size: 0.26rem;
  margin-right: 0.03rem;
}
.item .red {
  color: #ff514a;
  font-size: 0.26rem;
  margin-right: 0.03rem;
}
.redDw {
  color: #ff514a;
  font-size: 0.14rem;
}
.grayDw {
  color: #666;
  font-size: 0.14rem;
}
.opacity {
  opacity: 0.4;
}
.mescroll-empty {
  padding-top: 0.1rem;
  text-align: center;
}
.empty-tip {
  margin-top: 6px;
  font-size: 0.15rem;
  color: #ccc;
}
.empty-tip .empty-img {
  margin: 0 auto;
  width: 1.43rem;
  height: 1.22rem;
  margin-top: 1.14rem;
}
.lookBag,
.unlook {
  display: inline-block;
  width: 0.8rem;
  height: 0.3rem;
  background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 1) 0%,
    rgba(60, 100, 246, 1) 100%
  );
  border-radius: 15px;
  color: #fff;
  font-family: PingFangSC;
  font-size: 0.12rem;
  text-align: center;
  line-height: 0.3rem;
  position: relative;
  top: 0.13rem;
  right: -0.06rem;
}
.unlook {
  border-radius: 15px;
  /* opacity: 0.3; */
  border: 1px solid rgba(224, 224, 224, 1);
  color: #999999;
  background: #fff;
  position: relative;
  top: 0.16rem;
}
</style>
